import i18n from "../../i18n";

export const MAX_IMAGE_BYTES = 10_485_760;
export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp";
export const IMAGE_TOO_LARGE = "This image is too large. The maximum upload size is 10 MB. Please choose a smaller image.";

export const imageFileError = (file) => {
  if (file.size > MAX_IMAGE_BYTES) return i18n.t("uploads.image_too_large", { defaultValue: IMAGE_TOO_LARGE });
  // Empty/incorrect browser MIME is handled authoritatively by Brain's byte detection.
  if (file.type && !IMAGE_ACCEPT.split(",").includes(file.type)) {
    return i18n.t("uploads.unsupported_image");
  }
  return null;
};

export const imageUploadError = (error) => {
  if (error?.response?.status === 413) return i18n.t("uploads.image_too_large", { defaultValue: IMAGE_TOO_LARGE });
  const data = error?.response?.data;
  const safeCodes = ["file_required", "file_too_large", "unsupported_file_type", "invalid_image", "storage_unavailable"];
  if (safeCodes.includes(data?.error) && typeof data.message === "string") return data.message;
  if (!error?.response && (error?.request || error?.code === "ERR_NETWORK")) {
    return i18n.t("uploads.image_network_failure");
  }
  return i18n.t("uploads.image_failure");
};
